<template>
  <div>
    <template v-for="(col, colIndex) in formArr">
      <div
        :key="colIndex"
        class="form-wrap"
        :style="{'border-color': cloumnTitle === col.cloumnName && handleIndex === colIndex ? '#409EFF' : ''}">
        <div class="cloumn-title">
          <div>
            <span
              class="title"
              :style="{'color': cloumnTitle === col.cloumnName && handleIndex === colIndex  ? '#409EFF' : ''}"
              @click="editCloumn(col.cloumnName, colIndex, false)"
            >
              {{ col.cloumnName }}
            </span>
            <el-tooltip class="item" effect="dark" content="点击修改分栏名" placement="top">
              <i class="el-icon-edit" @click="editCloumn(col.cloumnName, colIndex, true)"></i>
            </el-tooltip>
            <i class="el-icon-delete" @click="deleteCloumn(col.cloumnName, colIndex)"></i>
          </div>
          <span class="tips">注：带有“*”必填项</span>
        </div>
        <el-form label-width="100px">
          <draggable v-model="col.list" filter=".forbid" @end="moveEnd" animation="300">
            <transition-group>
              <el-form-item
                v-for="(item, index) in col.list"
                :key="index"
                :label="item.fieldName"
                class="field-item"
                :required="item.isRequired"
                @click.native="handleItem(colIndex, index)"
                :class="isFlag(item) ? 'forbid' : ''">
                <div>
                  <div class="btn-wrap">
                    <span class="item-relevance" @click.stop="relevanceItem(colIndex, index)">题目关联</span>
                    <i class="el-icon-delete" @click.stop="deleteItem(colIndex, index)"></i>
                  </div>
                  <!-- <div class="text-wrap">
                    <span>表头</span>
                    <span>可搜索</span>
                  </div> -->
                  <template v-if="item.fieldType === 1">
                    <el-input
                      v-model="input"
                      :placeholder="item.extar['placeholder']"
                      class="width-m"
                    ></el-input>
                  </template>
                  <template v-else-if="item.fieldType === 2">
                    <el-input
                      type="textarea"
                      :rows="2"
                      :placeholder="item.extar['placeholder']"
                      v-model="textarea"
                      class="width-m">
                    </el-input>
                  </template>
                  <template v-else-if="item.fieldType === 3">
                    <el-input-number v-model="number" :min="1" :max="10" label="描述文字"></el-input-number>
                  </template>
                  <template v-else-if="item.fieldType === 4">
                    <el-radio-group v-model="radio">
                      <el-radio
                        v-for="radioItem in item.selectTypes"
                        :key="radioItem"
                        :label="radioItem"
                      >
                        {{ radioItem }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else-if="item.fieldType === 5">
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox
                        v-for="checkboxItem in item.selectTypes"
                        :key="checkboxItem"
                        :label="checkboxItem"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-else-if="item.fieldType === 6">
                    <el-select v-model="sigleSelect" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.fieldType === 7">
                    <el-select v-model="multipleSelect" multiple placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.fieldType === 8">
                    <el-date-picker
                      v-model="dateValue"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </template>
                  <template v-else-if="item.fieldType === 9">
                    <el-date-picker
                      v-model="datetimeValue"
                      type="datetime"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </template>
                  <template v-else-if="item.fieldType === 10">
                    <div>
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">文件类型：{{ item.fileTypes.join(",") }}</div>
                    </div>
                  </template>
                  <template v-else-if="item.fieldType === 11"></template>
                  <span class="show-tips" v-if="item.refText">{{ item.refText }}</span>
                </div>
              </el-form-item>
            </transition-group>
          </draggable>
        </el-form>
      </div>
    </template>
  </div>
</template>

<script>
// 控件
import draggable from "vuedraggable";
export default {
  name: "FormField",
  props: ["formList", "cloumnName", "cloumnIndex", "flagList"],
  components: {
    draggable
  },
  data() {
    return {
      formArr: this.formList,
      input: "",
      textarea: "",
      number: 10,
      radio: "",
      checkList: [],
      sigleSelect: "",
      multipleSelect: [],
      dateValue: "",
      datetimeValue: "",
      options: []
    }
  },
  computed: {
    cloumnTitle() {
      let title = this.cloumnName;
      return title;
    },
    handleIndex() {
      let index = this.cloumnIndex;
      return index;
    }
  },
  methods: {
    // 禁止拖动
    isFlag(item) {
      if (item.refFieldFlag) return true;
      if (this.flagList.includes(item.flag)) return true;
      return false;
    },
    // 删除分栏名
    deleteCloumn(title, index) {
      this.$emit("deleteCloumn", title, index);
    },
    // 编辑分栏名
    editCloumn(title, index, bool) {
      this.$emit("editCloumn", title, index, bool);
    },
    // 编辑控件规则
    handleItem(colIndex, index) {
      this.$emit("handleItem", colIndex, index)
      console.log(this.formList);
    },
    // 删除控件
    deleteItem(colIndex, index) {
      this.$emit("deleteItem", colIndex, index);
    },
    // 题目关联
    relevanceItem(colIndex, index) {
      this.$emit("relevanceItem", colIndex, index);
    },
    // 移动结束
    moveEnd() {
      this.$emit("update:formList", this.formArr);
    }
  }
}
</script>

<style lang="less" scoped>
.form-wrap {
  border: 1px solid #333;
  padding: 8px;
  margin-bottom: 15px;
  // display: flex;
  // justify-content: space-between;
}
.cloumn-title {
  border-bottom: 1px solid #999;
  padding-bottom: 5px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  position: relative;
  .title {
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    margin-right: 5px;
    user-select: none;
  }
  .tips {
    color: #999;
    font-size: 12px;
  }
  .el-icon-edit {
    cursor: pointer;
  }
  .el-icon-delete {
    cursor: pointer;
    margin-left: 10px;
  }
}
.field-item {
  // display: flex;
  border: 1px dashed #eee;
  // margin-bottom: 5px;
  padding: 15px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  &:hover {
    .btn-wrap {
      display: block;
    }
  }
  .btn-wrap {
    display: none;
    position: absolute;
    right: 0;
    bottom: -15px;
    z-index: 999;
  }
  // .text-wrap {
  //   position: absolute;
  //   left: -110px;
  //   bottom: -15px;
  //   z-index: 999;
  // }
  .width-m {
    max-width: 500px;
  }
  .el-icon-delete {
    color: #F56C6C;
    margin-left: 10px;
  }
  .item-relevance {
    text-decoration:underline;
    color: #666;
  }
  .show-tips {
    position: absolute;
    bottom: -20px;
    left: -100px;
    font-size: 12px;
    color: #E6A23C;
  }
}
</style>